// import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const Header = () => {

  return (
    <div className="row">
        <div className="col-12">
          <div className="card shadow-sm border-0" style={{
            border: "none",
            border: "2px solid #dee2e6",
            borderRadius: "15px",
            background: "#ffffff",
          }}>
            <div className="card-body p-3">
              <div className="row align-items-center">
                {/* Welcome Text - Left Side */}
                <div className="col-md-6 d-flex flex-column align-items-start">
                  <h5 className="mb-0" style={{
                    background: "linear-gradient(45deg, #664CBE, #4472C4)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    fontWeight: "bold",
                    fontSize: "1.8rem"
                  }}>
                    Skymark One - Parking Management System
                  </h5>
                </div>

                
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default Header;
